<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
    <div class="filter" :class="{open}" ref="container">
        <button class="btn btn-sm" @click="onToggleOpen()">
            <i class="bx bx-filter" ></i> Filter <span v-if="badge">({{ badge }})</span>
        </button>
        <div class="filter-body"><slot></slot></div>
    </div>
</template>